/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/prefer-default-export */
import React, { useEffect, useRef, useState } from "react";
// import { Typography } from '@ikhokha/ui-library';
// import './text-field.css';
import { ICheck, IEyeHide, IEyeShow, IWarning } from "./Icons";

type ITextField = {
  /**
   *Text input field type. text | password
   */
  type?:
    | "text"
    | "password"
    | "button"
    | "checkbox"
    | "radio"
    | "color"
    | "date"
    | "datetime-local"
    | "email"
    | "file"
    | "hidden"
    | "image"
    | "month"
    | "number"
    | "range"
    | "reset"
    | "select"
    | "search"
    | "submit"
    | "tel"
    | "time"
    | "url"
    | "week";
  /**
   *Text input field value
   */
  value?: string | number;
  /**
   *Text input field default value
   */
  defaultValue?: string;
  /**
   * Custom class name to pass to the input
   */
  className?: string | any;
  /**
   * Custom style to pass to the input
   */
  style?: object;
  /**
   *Text input field maximum length
   */
  maxLength?: number;
  /**
   *Text input field minimum length
   */
  minLength?: number;
  /**
   *Text input field placeholder
   */
  placeholder?: string | any;
  /**
   * Whether the button is disabled or not
   */
  disabled?: boolean;
  /**
   * Input field label
   */
  label?: string;
  /**
   * Help text to notify the user
   */
  helpText?: string | any;
  /**
   * The text is required
   */
  required?: boolean;
  /**
   * The required text to notify the user
   */
  requiredText?: string;
  /**
   * The text has error
   */
  error?: boolean;
  /**
   * Error message to display
   */
  errorMessage?: string | any;
  /**
   * Tooltip message to display
   */
  tooltip?: string;
  /**
   * Input field icon element
   */
  icon?: JSX.Element;
  /**
   * onChange event
   */
  onChange?: any;
  /**
   * Input field status
   */
  status?: "default" | "focused" | "complete" | "disabled" | any;
  /**
   * Status message to display
   */
  statusMessage?: string;
  /**
   * Text input name
   */
  name?: string;
  /**
   * Input ID
   */
  id?: string;
  /**
   * On focus function
   */
  onFocus?: any;

  /**
   * On blur function
   */
  onBlur?: any;
  /**
   * Add a prefix/symbol to the input
   */
  prefix?: string;

  /**
   * Max characters       xxx
   */
  showRemainingCharacters?: boolean;
};

export const TextField = (props: ITextField | undefined) => {
  const [hasFocus, setFocus] = useState(false);
  const ref = useRef<HTMLInputElement>(null);
  const [isInvalid, setInvalid] = useState(false);
  const [show, setShow] = useState(false);

  const handleTogglePassword = () => setShow(!show);

  if (!props) return <></>;

  const {
    id,
    type,
    name,
    value,
    defaultValue,
    className,
    maxLength,
    minLength,
    style,
    placeholder,
    disabled,
    label,
    helpText,
    required,
    requiredText,
    tooltip,
    icon,
    onChange,
    status,
    statusMessage,
    errorMessage,
    onFocus,
    onBlur,
    prefix,
    showRemainingCharacters,
  } = props;
  // const { id, type, name, value, defaultValue, className, style, placeholder, disabled, label, helpText, required, requiredText, tooltip, icon, onChange, status, statusMessage, errorMessage } = props;

  useEffect(() => {}, [show]);

  const scrollIntoView = () => {
    if (ref.current) ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <div className="form-control">
      {label && (
        <div className="label-wrapper">
          <label>
            {label}
            {required && " *"}
          </label>
          {tooltip && <div className="tooltip" />}
        </div>
      )}
      <div
        style={hasFocus ? { borderColor: "#FFCD00" } : {}}
        className={`input-wrapper ${status} ${isInvalid && "border-red"} ${hasFocus && "focus"} ${
          disabled && "border-light-grey bg-light-grey"
        } ${className}`}
      >
        {prefix && <span style={{ marginRight: "15px" }}>{prefix}</span>}
        <input
          id={id}
          type={show ? "text" : type}
          ref={ref}
          value={value}
          defaultValue={defaultValue}
          style={style}
          placeholder={placeholder}
          disabled={disabled}
          onFocus={(e) => {
            scrollIntoView();
            setFocus(true);
            if (onFocus) {
              onFocus(e);
            }
          }}
          onBlur={(e) => {
            setFocus(false);
            if (onBlur) {
              onBlur(e);
            }
          }}
          onInvalid={() => setInvalid(true)}
          onChange={onChange}
          onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
            if (type === "number" && /^[eE]*$/.test(e.key)) {
              e.preventDefault();
            }
          }}
          name={name}
          maxLength={maxLength}
          minLength={minLength}
        />
        {icon && <div className="input-icon-wrapper">{icon}</div>}
        {status === "complete" && (
          <div className="input-icon-wrapper">
            <ICheck width="24px" height="24px" />
          </div>
        )}
        {type === "password" && (
          <div className="input-icon-wrapper">
            {show ? <IEyeShow onClick={handleTogglePassword} /> : <IEyeHide onClick={handleTogglePassword} />}
          </div>
        )}
      </div>
      {showRemainingCharacters && maxLength && (
        <div className="remaining-characters">
          <div>Max characters</div>
          <div>{maxLength - (value?.toString() ?? "").length}</div>
        </div>
      )}
      {helpText && (
        <p className="my-1 help-text" style={{ marginLeft: "10px" }}>
          {helpText}
        </p>
      )}
      {requiredText && (
        <p className="my-1 required-text" style={{ marginLeft: "10px" }}>
          {requiredText && "*"}
          {requiredText}
        </p>
      )}
      {errorMessage && (
        <div style={{ display: "flex", paddingLeft: "10px" }}>
          <IWarning className="my-1" width="16px" height="16px" style={{ marginRight: "5px" }} />
          <p className="error-text" style={{ marginTop: "6px", marginBottom: "6px" }}>
            {errorMessage}
          </p>
        </div>
      )}
      <div style={{ display: "flex", marginLeft: "10px" }}>
        {status === "complete" && statusMessage && (
          <ICheck className="my-1" width="16px" height="16px" style={{ marginRight: "5px" }} />
        )}
        {statusMessage && status === "complete" && (
          <p className={`my-1 status-text ${status}`} style={{ marginTop: status === "complete" ? "6px" : "0px" }}>
            {statusMessage}
          </p>
        )}
      </div>
    </div>
  );
};

TextField.defaultProps = {
  type: "text",
  placeholder: "Text input field",
  label: "Label",
  required: false,
  requiredText: "",
};
